import { ShapePosition } from '../components/ShapePosition';
import { Shape } from '../components/Shape';
import { getShapes, getShapePosition } from './queryParamsHelper';

describe('getShapePosition', () => {
    it('rebuilds positions from query params when default positions are missing', () => {
        const queryParams = new URLSearchParams('shape1-left=250&shape1-top=280&shape2-left=400&shape2-top=280&shape3-left=550&shape3-top=280');

        const positions = getShapePosition(queryParams, []);

        expect(positions).toEqual([
            new ShapePosition(0, 250, 280),
            new ShapePosition(1, 400, 280),
            new ShapePosition(2, 550, 280),
        ]);
    });
});

describe('getShapes', () => {
    it('rebuilds hidden shapes from query params', () => {
        const initShapes = [
            Shape.create("circle", "circle.svg", "circle", "circle", 150, 0, 0, 150, 150, 447, 447, 0, 0, "#000000"),
            Shape.create("rhombus", "rhombus.svg", "rhombus", "rhombus", 0, 0, 0, 0, 0, 414, 414, 45, 45, "#000000"),
            Shape.create("square", "square.svg", "square", "rect", 0, 0, 0, 0, 0, 344, 344, 0, 0, "#000000"),
        ];
        const shapePalette = [
            ...initShapes,
            Shape.create("hidden", "hidden.png", "hide", "hidden", 0, 100, 50, 100, 50, 200, 100, 0, 0, "#000000", true),
        ];
        const queryParams = new URLSearchParams('shape1-name:hidden&shape2-name:rhombus&shape3-name:hidden'.replaceAll(':', '='));

        const shapes = getShapes(queryParams, initShapes, shapePalette, 7);

        expect(shapes[0].tagName).toBe('hidden');
        expect(shapes[1].name).toBe('rhombus');
        expect(shapes[2].tagName).toBe('hidden');
    });
});
